// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"K8-z"};